/*!
 * LSP用
 * フォルダ：lsp1
 * パターン1（コントロール）
 */

// import Loading from './modules/loading';
import Button from 'bootstrap/js/dist/button';
import Collapse from 'bootstrap/js/dist/collapse';
// import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Gnav from './modules/gnav';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
// ▼ツールチップを初期化
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  //new Tooltip() でインスタンスを生成
  return new Tooltip(tooltipTriggerEl)
});
// ▲ツールチップを初期化
import './lsp1/style.scss';